import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left-aligned mt-6" }
const _hoisted_2 = { class: "meb-title" }
const _hoisted_3 = { class: "mt-4 mb-6" }
const _hoisted_4 = { class: "meb-text-p" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "meb-text-p-orange" }, "Magna e Basta ", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "pb-6" }
const _hoisted_8 = { class: "carousel-container" }

import HomeSectionCarouselComponent from '@/components/HomeSectionCarouselComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSection1Component',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('SEC_1_TITLE')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          innerHTML: _ctx.$t('SEC_1_DESC')
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_138306903.png",
          name: "SEC_1_1"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_113625305.png",
          name: "SEC_1_2"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_419253624.png",
          name: "SEC_1_3"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_293215232.png",
          name: "SEC_1_4"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_513099390.png",
          name: "SEC_1_5"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_268468367.png",
          name: "SEC_1_6"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_182726631.png",
          name: "SEC_1_7"
        }),
        _createVNode(HomeSectionCarouselComponent, {
          image: "carousel/AdobeStock_462540795.png",
          name: "SEC_1_8"
        })
      ])
    ])
  ]))
}
}

})